import { DatePicker, Divider, Flex } from 'antd'

import { PageBreadcrumbs, SearchBar, Select } from 'src/components'
import { useLocales } from 'src/locales'

import { ReportsTable } from '../components/ReportsTable'

const { RangePicker } = DatePicker

export const ReportsPage = () => {
  const { t } = useLocales()

  const onSearch = () => null

  return (
    <PageBreadcrumbs
      title={t('menu.reports')}
      items={[
        {
          title: t('menu.reports')
        }
      ]}
    >
      <Flex gap={16}>
        <SearchBar
          onSearch={onSearch}
          placeholder={t('reports.search_by_report_title')}
        />

        <Select placeholder={t('reports.report_type')} />

        <Select placeholder={t('common.by_department')} />

        <RangePicker />
      </Flex>

      <Divider />

      <ReportsTable />
    </PageBreadcrumbs>
  )
}
